import comment from "liquidjs/dist/tags/comment";
import { CurrencyTypes } from "./currency-types";
import { PriceDetails } from "./price-details";
import { immerable } from "immer";

export class CurrencyPriceInfos {
  [immerable] = false;
  price: number | null = 0;
  currency: CurrencyTypes | null = null;
  priceDetails: PriceDetails[] | null = [];

  constructor(init?: Partial<CurrencyPriceInfos>) {
    Object.assign(this, init);
  }
}
